export default defineI18nConfig(() => ({
  legacy: false,
  locale: 'de',
  fallbackLocale: {
    de_marketing_environment: ['de'],
  },
  flatJson: true,
}))
